import { trackAddtoCart, trackRemoveFromCart } from '../../services/tracking';
import Pluralize from 'react-pluralize';
import { StyledCoffee } from './style';

import { Button } from '../button';

function Coffee({ formikRef, coffee, validate, updateCoffees }){
  const gradientStyle = {
    '--gradient-from': coffee.gradient_from_color,
    '--gradient-mid': coffee.gradient_mid_color,
    '--gradient-to': coffee.gradient_to_color
  }

  const backgroundStyle = {
    backgroundImage: `url('${coffee.flavour_image_url}')`
  }

  const Item = (props) => {
    return(
      <div className="item">
        {props.title ? <div className="title">{props.title}</div> : ''}
        <div className="value">{props.value}</div>
      </div>
    )
  }

  const RemoveButton = (props) => {
    if(formikRef.current && formikRef.current.values && formikRef.current.values.coffees && formikRef.current.values.coffees[coffee.id]){
      return <Button type="button" buttonStyle="inverse" size="extra-small" onClick={decrease}>
        Remover
      </Button>
    }
    else {
      return null;
    }
  }

  const Quantity = () => {
    let quantity = '';

    if(formikRef.current && formikRef.current.values && formikRef.current.values.coffees){
      quantity = formikRef.current.values.coffees[coffee.id];
    }

    return(
      <div className="quantity">
        {quantity ? <Pluralize singular="café" count={quantity} /> : ''}
      </div>
    )
  }

  const increase = async () => {
    let coffees = { ...formikRef.current.values.coffees };

    coffees[coffee.id] = coffees[coffee.id] || 0;
    coffees[coffee.id]++;

    await updateCoffees(coffees);
    validate();

    trackAddtoCart();
  }

  const decrease = async () => {
    let coffees = { ...formikRef.current.values.coffees };

    if(coffees[coffee.id]) coffees[coffee.id]--;
    if(coffees[coffee.id] === 0) delete coffees[coffee.id];

    await updateCoffees(coffees);
    validate();

    trackRemoveFromCart();
  }

  return (
    <StyledCoffee className="coffee">
      <div className="coffee-box">
        <div className="name">{coffee.name}</div>
        <div className="gradient" style={gradientStyle}></div>

        <div className="items">
          <div className="background" style={backgroundStyle}></div>
          <Item value={coffee.farm} />
          <Item value={coffee.origin} title="Origem" />
          <Item value={coffee.sweetness} title="Sabor" />
          <Item value={coffee.roast_profile} title="Perfil de torra" />
          <Item value={coffee.altitude} title="Altitude" />
          <Item value={coffee.praparation_process} title="processamento" />
        </div>

        <div className="actions">
          <Quantity />

          <div>
            <RemoveButton />

            <Button type="button" buttonStyle="inverse" size="extra-small" onClick={increase}>
              Adicionar
            </Button>
          </div>
        </div>
      </div>
    </StyledCoffee>
  )
}

export default Coffee;
